export const GoShareID = '5760ab8f-af32-43db-92d8-d5e53ad6d660';
export const DotsID = '9359aa0c-a4a2-4977-a94b-c4693f227488';
